import { render, staticRenderFns } from "./ricercaGaranzie_contraenza.vue?vue&type=template&id=ace5dda0&"
import script from "./ricercaGaranzie_contraenza.vue.ts?vue&type=script&lang=ts&"
export * from "./ricercaGaranzie_contraenza.vue.ts?vue&type=script&lang=ts&"
import style0 from "./ricercaGaranzie_contraenza.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports